
import React from "react";
import SVG from "react-inlinesvg";
import { Modal } from "react-bootstrap";
import {  useSelector, shallowEqual, useDispatch } from "react-redux";
import { toAbsoluteUrl } from "../../../../../../../../../_metronic/_helpers";
import * as handlers from "../../../../../../_redux/selected-user/selectedUserHandlers"

const DeleteBankAccountModal = ({showDeleteBankAccountModal, onHide, details}) => {

    const dispatch = useDispatch();
    /* Get user Basic information from redux */
    const userBasic = useSelector(({selectedUser}) => selectedUser.data.profile.basic, shallowEqual);

    // Delete Bank Account
    const deleteBankAccount = (userId, ref) => {
        const meta = {...userBasic, bankAccount: details};
        onHide();
        dispatch(handlers.deleteBankAccount(userId, ref, {meta}));
    }

  return (
    <Modal
        show={showDeleteBankAccountModal}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
      >
      
        <Modal.Header >
          <Modal.Title id="contained-modal-title-vcenter">
            <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                <SVG
                    title=""
                    src={toAbsoluteUrl("/media/svg/icons/Shopping/Money.svg")}
                />
            </span>
            Delete Bank Account Confirmation
          </Modal.Title>
          <button type="button" className="close" onClick={onHide}>
              <span aria-hidden="true" className="d-block">×</span>
              <span className="sr-only">Close</span>
           </button>
        </Modal.Header>
        <Modal.Body 
            className="px-10 py-2"
        >   
            <h5
                className="text-center font-weight-light py-5"
            >
                Do you really want to delete <b> {details?.bankName} 
                <span className="text-muted pl-2">***{details?.accountNumber?.substr(-4)} - {details?.currency}</span></b> ?
            </h5>
        </Modal.Body>
        <Modal.Footer>
            <button
                type="button"
                onClick={onHide}
                className="btn btn-light btn-elevate px-4"
            >
                Close
            </button>
            <> </>
            <button
                type="button"
                onClick={_ => deleteBankAccount(details?.userId, details?.ref)}
                className="btn btn-danger btn-elevate px-4 ml-4"
            >
                Delete Bank Account
            </button>
        </Modal.Footer>
      </Modal>

        );
}

export default DeleteBankAccountModal;